import api from './api';
import type { CrmKpiDashboard, CrmKpiFiltro } from '../types/crm';

const crmKpiService = {
  getDashboard: async (params: CrmKpiFiltro = {}): Promise<CrmKpiDashboard> => {
    const response = await api.get<CrmKpiDashboard>('/api/CrmKpis', { params });
    return response.data;
  },

  exportCsv: async (params: CrmKpiFiltro = {}): Promise<Blob> => {
    const response = await api.get<Blob>('/api/CrmKpis/export', {
      params,
      responseType: 'blob',
    });
    return response.data;
  },
};

export default crmKpiService;
